import { formAnswerSchema } from '@models/schema'
import { createSelector, createSlice } from '@reduxjs/toolkit'
import { fetchFormAnswers } from '@services/membership/FormAnswerService'
import {
  baseReducers,
  getIdOrModelId,
  SBAPI,
  SBSelectRaw,
  SBState,
} from '@supplement-bacon/react-toolkit/utils'
import { initialQuery, TableParams } from '@supplement-bacon/sb-table-filters'
import { FormAnswer } from '../../models/membership/Form'
import { AppDispatch, RootState } from '../store'

const initialState: SBState<FormAnswer> = {
  isLoading: false,
  error: null,
  items: {},
  ids: [],
  selectedId: undefined,
  query: initialQuery,
}

const slice = createSlice({
  name: 'formAnswer',
  initialState,
  reducers: baseReducers,
})

// Reducer
export default slice.reducer
export const {
  getItemsSuccess: getFormAnswersSuccess,
  setQuery: setFormAnswerQuery,
  reset: resetFormAnswerState,
  resetQueryAndIds: resetFormAnswerQueryAndIds,
} = slice.actions

/**
 * Selectors
 */

const selectRawItems: SBSelectRaw<RootState, { [key: number]: FormAnswer }> = (
  state: RootState
) => state[slice.name].items
const selectRawIds: SBSelectRaw<RootState, number[]> = (state: RootState) =>
  state[slice.name].ids
const selectRawSelectedId: SBSelectRaw<RootState, number | undefined> = (
  state: RootState
) => state[slice.name].selectedId

export const selectFormAnswers = () =>
  createSelector(
    [selectRawItems, selectRawIds],
    (items, ids) => ids.map((id) => items[id]).filter((i) => i)
    // Filter allow to return only non-null elements
  )
export const selectSelectedFormAnswer = () =>
  createSelector([selectRawItems, selectRawSelectedId], (items, id) =>
    id !== undefined ? items[id] : undefined
  )
export const selectFormAnswerById = (id: number) =>
  createSelector([selectRawItems], (items) =>
    items.hasOwnProperty(id) ? items[id] : undefined
  )
export const selectFormAnswersByIds = (ids: number[]) =>
  createSelector([selectRawItems], (items) =>
    ids.filter((id) => items.hasOwnProperty(id)).map((id) => items[id])
  )

/**
 * Actions
 */

export const setSelectedFormAnswer =
  (formAnswer: FormAnswer | number) => async (dispatch: AppDispatch) =>
    dispatch(
      slice.actions.setSelectedId(getIdOrModelId<FormAnswer>(formAnswer))
    )

export const getFormAnswers = (params: TableParams) =>
  SBAPI.FetchPaginatedDispatched(
    fetchFormAnswers(params),
    [formAnswerSchema],
    slice.actions
  )
